module.exports = __webpack_public_path__ + "img/logo_entreprise.13ed2854.png";